import { cn } from "@/lib/utils";

/**
 * Smooth pink wave divider between sections.
 * variant "blush" = blush pink fading up to white (use on light sections).
 * variant "pink"  = soft pink gradient band.
 * variant "toDeep" = deep section -> blush.
 */
export function WaveDivider({
  className,
  variant = "blush",
}: {
  className?: string;
  variant?: "blush" | "pink" | "toDeep" | "toBlush";
}) {
  const fill =
    variant === "pink"
      ? "url(#wavePink)"
      : variant === "toDeep"
        ? "url(#waveToDeep)"
        : variant === "toBlush"
          ? "url(#waveToBlush)"
          : "url(#waveBlush)";
  return (
    <div className={cn("pointer-events-none relative w-full", className)} aria-hidden>
      <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        className="block h-[60px] w-full md:h-[90px]"
        role="presentation"
      >
        <defs>
          <linearGradient id="waveBlush" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="oklch(0.945 0.038 351)" />
            <stop offset="100%" stopColor="oklch(0.994 0.006 350)" />
          </linearGradient>
          <linearGradient id="wavePink" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="oklch(0.7 0.165 352)" />
            <stop offset="100%" stopColor="oklch(0.945 0.038 351)" />
          </linearGradient>
          <linearGradient id="waveToDeep" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="oklch(0.994 0.006 350)" />
            <stop offset="100%" stopColor="oklch(0.18 0.006 285)" />
          </linearGradient>
          <linearGradient id="waveToBlush" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="oklch(0.18 0.006 285)" />
            <stop offset="100%" stopColor="oklch(0.945 0.038 351)" />
          </linearGradient>
        </defs>
        <path
          d="M0,64 C240,112 480,112 720,72 C960,32 1200,32 1440,72 L1440,120 L0,120 Z"
          fill={fill}
        />
      </svg>
    </div>
  );
}
